// extracted by mini-css-extract-plugin
export default {"header":"Header-module__[local]___lOnzS","title":"Header-module__[local]___5Kz6z"};